<script setup>
/* global axios */
// axios GLOBAL (window.axios, APIHelper.js): é ele que leva os cabeçalhos de
// login (access-token/client). O 'axios' cru saía sem eles e voltava 401.
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import messages from './en.json';
import ptBRMessages from './pt_BR.json';

const enabled = ref(false);
const { t } = useI18n({
  useScope: 'local',
  // pt_BR além do en: quem usa em português via a tela toda em inglês.
  messages: { en: messages, pt_BR: ptBRMessages },
  fallbackLocale: 'en',
});
onMounted(async () => {
  try {
    await axios.get('/api/v1/mcp_connections');
    enabled.value = true;
  } catch {
    enabled.value = false;
  }
});
</script>

<template>
  <div>
    <a
      v-if="enabled"
      href="/app/mcp/authorize"
      class="my-4 inline-flex min-h-11 items-center text-sm text-n-blue-11 underline"
    >
      {{ t('CONNECTIONS') }}
    </a>
  </div>
</template>
